export default {
  independentMarketing: {
    common: {
      requestFailed: '介面請求失敗',
      hintSelect: '請選擇',
      hintInput: '請輸入',
      submit: '提交',
      cancel: '取消',
      confirm: '確定',
    },
    agreement: {
      title: 'Autel自主行銷經銷商註冊協定',
      nextBtn: '下一步',
      getAgreementFailed: '獲取協定內容失敗',
    },
    successPage: {
      title: '您的申請資訊已提交成功，審核結果將在15個工作日內發送至您的郵箱$1，請注意及時查收。',
      subTitle: '$1s 後自動返回首頁',
    },
    applyTitle: '您正在申請成為Autel自主行銷經銷商，請如實填寫以下資訊：',
    companyName: '企業名稱',
    companyTax: '企業稅號',
    userCountry: '所在國家',
    legalPerson: '法人姓名',
    contactEmail: '連絡人郵箱',
    contactEmailTips: '此郵箱將會收到審核結果郵件，且審核通過後將被用作自主經銷商管理系統登錄帳號。',
    corporateIdentity: '法人身份證件',
    uploadTips: 'JPG、JPEG、PNG、PDF，不超過20M',
    businessLicense: '企業營業執照',
    emailErrorTips: '請輸入正確的郵箱',
    uploadPic: '上傳照片',
    picMaxLimit: '圖片最大支援20M，請重新選擇',
  },
};
